"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var catalog;
        (function (catalog) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.validationErrorMessage = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    let launchExample = appn.utils.getUrlParamByName('launch');
                    if (launchExample) {
                        launchExample = decodeURIComponent(launchExample);
                        $(`div[data-item-name="${launchExample}"]`).click();
                    }
                }
                index.init = init;
                function addEvents() {
                    $('.storeListing').on('click', function (event) {
                        event.stopPropagation();
                        showExampleDialog($(this));
                    });
                    $('#installContent').on('click', function (event) {
                        event.stopPropagation();
                    });
                    $('.btn[name="submitType"]').on('click', function (event) {
                        document.forms[1].submit();
                    });
                    $('.more').on('click', function (event) {
                        if ($(this).prev().hasClass('category_open')) {
                            $(this).prev().removeClass('category_open');
                            $(this).html(appn.strings.viewMore);
                        }
                        else {
                            $(this).prev().addClass('category_open');
                            $(this).html(appn.strings.viewLess);
                        }
                    });
                }
                function showExampleDialog($exampleTagWithData) {
                    const id = $('#itemId');
                    const name = $('.modal-title');
                    const descr = $('#itemDescription');
                    const icon = $('#itemIcon');
                    id.val($exampleTagWithData.attr('data-item-id'));
                    name.text($exampleTagWithData.attr('data-item-name'));
                    descr.html($exampleTagWithData.attr('data-item-descr'));
                    icon.attr('src', $exampleTagWithData.data('itemIcon'));
                    icon.attr('data-imglazyurl', $exampleTagWithData.data('itemIcon'));
                    const bg = $exampleTagWithData.find('.templateItem img').css('background-color');
                    icon.css('background-color', bg);
                    if (_initArgs.validationErrorMessage) {
                        let launchExample = appn.utils.getUrlParamByName('launch');
                        if (launchExample)
                            launchExample = decodeURIComponent(launchExample);
                        if (String($exampleTagWithData.attr('data-item-name')) === launchExample) {
                            const modalwarning = $('#installTemplateDialog').find('.card-body h4');
                            if (modalwarning.length === 0)
                                employInstallValidationAndMutation();
                        }
                        else
                            removeInstallValidationAndMutation();
                    }
                    $('#installTemplateDialog').modal('show');
                }
                function employInstallValidationAndMutation() {
                    const parser = new DOMParser();
                    const messageDoc = parser.parseFromString(_initArgs.validationErrorMessage, 'text/html');
                    const message = $(messageDoc.body).children();
                    const messageContainer = document.createElement('div');
                    messageContainer.classList.add('alert', 'alert-danger');
                    message.appendTo(messageContainer);
                    const modal = $('#installTemplateDialog');
                    const modalStyle = modal.find('.modal-dialog');
                    const modalButtons = modal.find('.modal-toolbar');
                    const modalBody = modal.find('.card-body');
                    modalStyle.removeClass('modal-info');
                    modalStyle.addClass('modal-danger');
                    const installButton = modalButtons.find('#installBtn');
                    installButton.removeClass('btn-success');
                    installButton.addClass('btn-warning');
                    installButton.find('span').text('Overwrite');
                    $('#EnableForce').val('true');
                    modalBody.prepend(messageContainer);
                }
                function removeInstallValidationAndMutation() {
                    const modal = $('#installTemplateDialog');
                    const modalStyle = modal.find('.modal-dialog');
                    const modalButtons = modal.find('.modal-toolbar');
                    const modalBody = modal.find('.card-body');
                    modalStyle.removeClass('modal-danger');
                    modalStyle.addClass('modal-info');
                    const installButton = modalButtons.find('#installBtn');
                    installButton.removeClass('btn-warning');
                    installButton.addClass('btn-success');
                    installButton.find('span').text('Install');
                    $('#EnableForce').val('false');
                    const messageContainer = modalBody.find('div.alert.alert-danger');
                    messageContainer.remove();
                }
            })(index = catalog.index || (catalog.index = {}));
        })(catalog = views.catalog || (views.catalog = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
